import { render } from "./Submenus.vue?vue&type=template&id=48a64606"
import script from "./Submenus.vue?vue&type=script&lang=js"
export * from "./Submenus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__